(function () {
  'use strict';

  angular
      .module('tf.retailer.Analytics')
      .factory('ExperimentApi', ExperimentApi);

  // @ngInject
  function ExperimentApi(Api) {

    return {
      find : find,
      get : get
    };

    function find(tla) {
      if (tla == undefined) {
        return Api.get('/experiment');
      } else {
        return Api.get('/experiment/' + encodeURIComponent(tla));
      }
    }

    function get(tla, experimentKey) {
      return Api.get('/experiment/' + encodeURIComponent(tla) + '/' + encodeURIComponent(experimentKey));
    }
  }

})();
